module.exports = __webpack_public_path__ + "static/screen3-c8cedaa89aac37a2d6129982f443efbb.webp";